<template>
    <div style="position: relative;">
        <NavBar :index="5" />
        <!-- 轮播图 -->
        <img class="top-nav" src="../assets/tops.png" alt="返回顶部" @click="topOne">
        <swiper :options="swiperOption" ref="mySwiper" id="mySwiper">
            <!-- 轮播图0 -->
            <swiper-slide class="swiper_slide_item">
                <swiper :options="swiperTop" ref="swiperTop" id="swiperTop">
                    <swiper-slide>
                        <div class="one-card"
                            style=" border-radius: 0; position: relative; width: 100vw; height: 100vh;margin: 0;">
                            <video src="https://zhg-wec-online.oss-cn-shenzhen.aliyuncs.com/8%E6%9C%887%E6%97%A5.mp4"
                                autoplay muted loop
                                style="position: absolute; top: 0; left: 0; width: 100vw; height: 100%; object-fit: cover;"
                                preload="auto">
                            </video>
                            <div class="textara">
                                <div class="text-cons">新闻资讯</div>
                                <div class="text-fonts">了解最新行业资讯，技术应用和公司动态</div>
                            </div>
                        </div>
                    </swiper-slide>
                    <!--分页器-->
                    <!-- <div class="top-pagination" slot="pagination"></div> -->
                </swiper>
            </swiper-slide>
            <!-- 1合作方式-->
            <swiper-slide class="swiper_slide_item">
                <div class="tit-top" :class="activeIndex == 1 ? 'animated-news-item' : ''">新闻资讯</div>
                <div class="backCon">
                    <div class="cardTwo">
                        <!-- 左箭头按钮 -->
                        <div class="left-button" @click="prevCardPage">
                            <img src="../assets/butzuo.png" alt="">
                        </div>
                        <div class="twos-con" v-if="!loinshow">
                            <div class="twos-item" v-for="(a, index) in newsDatas" :key="index" @click="handleClick(a)">
                                <img :src="a.pic" alt="Image" class="twos-img">
                                <div class="twos-text">{{ a.title }}</div>
                                <div class="hover-overlay">
                                    <div class="lgs">
                                        <div style="color: #fff;">查看详情</div>
                                        <img src="../assets/yjts.png" alt="">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="twos-con" v-else
                            style=" height:680px; display: flex; justify-content: center; align-items: center; flex-direction: column;">
                            <div class="loading-animation"></div>
                            加载中...
                        </div>
                        <!-- 第一张卡片：核心优势 -->
                        <!-- 右箭头按钮 -->
                        <div class="right-button" @click="nextCardPage">
                            <img src="../assets/butyou.png" alt="">
                        </div>
                    </div>
                    <div
                        style=" width: 12dvb; position: absolute; bottom: 100px; display: flex;align-items: center;justify-content: space-between;">
                        <div v-for="(a, index) in 8" class="dots" :class="pages == (index + 1) ? 'dotsActive' : ''">
                        </div>
                    </div>
                </div>

            </swiper-slide>
            <!-- 6底部-->
            <swiper-slide class="swiper_slide_item">
                <!-- 底部 -->
                <div class="card-imgs" :class="activeIndex == 2 ? 'animated-image' : ''">
                    <video
                        src="https://zhg-wec-online.oss-cn-shenzhen.aliyuncs.com/901c15307e666d31943878a152a23e61_raw.mp4"
                        autoplay muted loop style="width: 100%; height: 100%;  object-fit: cover;" preload="auto">
                    </video>
                    <div class="gradient-con">
                        <div class="gradient-text ">链上生态互融 共享数字未来</div>
                        <div class="gradient-p">智慧谷-您的企业数改服务商</div>
                    </div>
                </div>
                <div class="footer" :class="activeIndex == 2 ? 'animated-image' : ''">
                    <div class="footer_top">
                        <!-- 左 -->
                        <div class="footerTopLeft">
              <!-- 1 -->
              <div class="LeftCon" style="cursor: pointer;">
                <h4 @click="jumps(0)">走进智慧谷</h4>
                <p @click="jumps(1)">集团介绍</p>
                <p @click="jumps(5)">发展历程</p>
                <p @click="jumps(7)">企业荣誉</p>
              </div>
              <div class="LeftCon" style="cursor: pointer;">
                <h4 @click="jumphx(0)">核心业务</h4>
                <p  @click="jumphx(5)">CHAIN企业链改服务</p>
                <p  @click="jumphx(8)">企链通DAPP数商平台</p>
                <p  @click="jumphx(11)">智慧谷AI名片</p>
              </div>
              <div class="LeftCon" style="cursor: pointer;">
                <h4 @click="jumpcj(0)">应用场景</h4>
                <p @click="jumpcj(2)">数字支付</p>
                <p @click="jumpcj(3)">数字商城</p>
                <p @click="jumpcj(19)">数字三农</p>
              </div>
              <div class="LeftCon" style="cursor: pointer;">
                <h4 @click="jumpgh(0)">合作规划</h4>
                <p @click="jumpgh(1)">合作流程</p>
                <p @click="jumpgh(2)">合作收益</p>
                <p @click="jumpgh(4)">全球战略</p>
              </div>
            </div>
                        <!-- 右 -->
                        <div class="footerTopRight">
                            <!-- 1 -->
                            <!-- <div class="RightCon" style="font-size: 20px;">
                          <p style="cursor: pointer;">联系我们</p>
                      </div> -->
                            <div class="RightCon">
                                <img src="../assets/tel.png" mode=""></img>
                                <p>电话：400-8537-168</p>
                            </div>
                            <div class="RightCon">
                                <img src="../assets/web.png" mode=""></img>
                                <p style="cursor: pointer;">网址：www.gjzhg.com</p>
                            </div>
                            <div class="RightCon">
                                <img src="../assets/email.png" mode=""></img>
                                <p style="cursor: pointer;">邮箱：zhgjt@gjzhg.com</p>
                            </div>
                            <div class="RightCon">
                                <img src="../assets/dz.png" mode=""></img>
                                <p style="cursor: pointer;">地址：福建省厦门市集美区杏林湾营运中心总部大厦6号楼</p>
                            </div>
                            <!-- code -->
                            <div class="code">
                                <div
                                    style="display: flex; align-items: center; justify-content: center;flex-direction: column;">
                                    <img src="../assets/gzh.jpg" alt=""
                                        style="width: 90px;height: 90px;border-radius: 10px;">
                                    <h5 style="cursor: pointer;">扫一扫关注我们</h5>
                                </div>
                                <div
                                    style="display: flex; align-items: center; justify-content: center;flex-direction: column;">
                                    <img src="../assets/kf.png" alt=""
                                        style="width: 90px;height: 90px;border-radius: 10px;">
                                    <h5 style="cursor: pointer;">扫一扫添加客服</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="footer_botm">
                        <p style="text-indent:1em;">版权所有：智慧谷(福建)数字科技集团有限公司</p>
                        <p style="text-indent:1em;">&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;</p>
                        <p style="text-indent:1em;">闽ICP备16005520号-1</p>
                        <p style="text-indent:1em;">&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;</p>
                        <p style="text-indent:1em;">本网站由阿里云提供云计算及安全服务 </p>
                        <p style="text-indent:1em;">&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;</p>
                        <p style="text-indent:1em;"> 本网站支持 IPv6 </p>
                        <p style="text-indent:1em;">|</p>
                        <p style="text-indent:1em;"> Powered by CloudDream </p>
                    </div>
                </div>
            </swiper-slide>
            <!-- 可选的控件 -->
            <!--分页器-->
            <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
    </div>
</template>
<script>
import axios from 'axios';
import NavBar from '../components/NavBar.vue';

export default {
    components: {
        NavBar
    },
    name: "FullPage",
    data() {
        return {
            loinshow: false,
            activeIndex: 0,
            newsDatas: [],//循环新闻
            // 核心业务
            pageIndex: 0,
            businessActive: 0,
            timeoutId: null,    // 用于清除 15 秒超时的计时器
            intervalId: null,   // 用于清除自动切换 tab 的定时器
            // 导航栏
            topTabActive: 0,
            // swiper 配置
            swiperOption: {
                direction: "vertical", // swiper 方向
                mousewheel: true,
                // 分页器
                pagination: {
                    el: ".swiper-pagination", //分页器的类名
                    clickable: true, // 点击分页器跳切换到相应的幻灯片
                },
                on: {
                    // 翻页
                    slideChange: () => {
                        // 记录当前页index
                        this.activeIndex = this.$refs.mySwiper.$swiper.activeIndex
                        console.log(this.activeIndex, ' this.activeIndex')
                    },
                }
            },
            // 顶部
            swiperTop: {
                direction: "horizontal", // swiper 方向
                mousewheel: true,
                // autoplay: { delay: 13000, disableOnInteraction: false },
                // 分页器
                pagination: {
                    el: ".top-pagination", //分页器的类名
                    clickable: true, // 点击分页器跳切换到相应的幻灯片
                },
                on: {
                    // 翻页
                    slideChange: () => {
                        // 同步tab状态
                        if (this.$refs.swiperTop && this.$refs.swiperTop.$swiper) {
                            this.topTabActive = this.$refs.swiperTop.$swiper.activeIndex;
                        }
                    },
                }
            },
            pages: 1,
        };
    },
    mounted() {
        this.getNews();
        // 初始化定时器,开始监听
        // this.autoSwitchTab();
        // this.resetTimeout();
        let that = this
        if (that.$route.query.num && that.$route.query.num != 0) {
            this.activeIndex = that.$route.query.num * 1;
            if (that.$refs.mySwiper && that.$refs.mySwiper.$swiper) {
                that.$refs.mySwiper.$swiper.slideTo((that.$route.query.num * 1) + 0);
                console.log((that.$route.query.num * 1) + 1);
            }
        } else {
            this.activeIndex = 0;
            if (that.$refs.mySwiper && that.$refs.mySwiper.$swiper) {
                that.$refs.mySwiper.$swiper.slideTo(0);
            }
        }


    },
    watch: {
        // 监听 businessActive 变量的变化
        businessActive(newVal, oldVal) {
            // 每次 businessActive 变化时,重置15秒的计时器
            clearTimeout(this.timeoutId);
            this.resetTimeout();
        },
        // 视频切换一直播放
        activeIndex(newVal, oldVal) {
            // console.log(newVal, oldVal,'ppppppp');
            if (newVal == 3) {
                let video = this.$refs.video1;  // 获取视频元素
                if (video) {
                    video.currentTime = 0;  // 将视频播放时间重置为 0
                    video.play();  // 播放视频
                }
            }
            // 链改服务内容
            if (newVal == 4) {
                let video = this.$refs.video2;  // 获取视频元素
                if (video) {
                    video.currentTime = 0;  // 将视频播放时间重置为 0
                    video.play();  // 播放视频
                }
            }
        },
        // 页面需要
        '$route.query.num': function (newNum) {
            // 这里是num变化时执行的操作
            let that = this
            if (that.$route.query.num != 0) {
                console.log('num changed:', newNum);
                this.activeIndex = that.$route.query.num * 1;
                console.log(that.$route.query.num)
                if (that.$refs.mySwiper && that.$refs.mySwiper.$swiper) {
                    that.$refs.mySwiper.$swiper.slideTo((that.$route.query.num * 1) + 0);
                    console.log((that.$route.query.num * 1) + 1);
                }
            } else {
                console.log('num chassssnged:', newNum);

                this.activeIndex = 0;
                if (that.$refs.mySwiper && that.$refs.mySwiper.$swiper) {
                    that.$refs.mySwiper.$swiper.slideTo(0);
                }
            }
        }
    },
    methods: {
        nextCardPage() {
            if (this.pages <= 7) {
                let a = this.pages++
                this.getNewsList(a)
            } else {
                this.pages = 1
                this.getNewsList(this.pages)
            }
        },
        prevCardPage() {
            if (this.pages > 1) {
                let a = this.pages--
                this.getNewsList(a)
            }
        },

        // 跳转新闻详情
        handleClick(newsItem) {
            console.log(newsItem, 'pppppp');
            localStorage.setItem('selectedNews', JSON.stringify(newsItem));
            this.$router.push({ name: 'message' });
        },
        // 轮播图的tab
        switchTopTab(index) {
            console.log(index);
            this.topTabActive = index;
            // 同步轮播图
            if (this.$refs.mySwiper && this.$refs.mySwiper.$swiper) {
                this.$refs.mySwiper.$swiper.slideTo(index + 1);
            }
        },
        switchTab(index) {
            this.businessActive = index;
            this.pageIndex = index;
            // 清除定时器,重置 15 秒的计时
            clearTimeout(this.timeoutId);
            // 重启15秒监控
            this.resetTimeout();

            // 如果有正在进行的定时器,清除并重新启动自动切换定时器
            clearInterval(this.intervalId);
            // this.autoSwitchTab();
        },
        // 监控 businessActive 的变化,如果15秒没有变化则触发 autoSwitchTab
        // resetTimeout() {
        //     this.timeoutId = setTimeout(() => {
        //         this.autoSwitchTab(); // 如果15秒内没有变化,触发自动切换 tab
        //     }, 15000); // 15秒没有变化则触发
        // },
        topOne() {
            this.$refs.mySwiper.$swiper.slideTo(0);
            this.activeIndex = 0
        },
        // 5个
        jumps(a) {
            let timestamp = Date.now();
            this.$router.replace({ name: 'IntoZhg', query: { num: a, time: timestamp } })
        },

        jumphx(a) {
            let timestamp = Date.now();
            this.$router.replace({ name: 'DevelopmentStrategy', query: { num: a, time: timestamp } })
        },

        jumpcj(a) {
            let timestamp = Date.now();
            this.$router.replace({ name: 'core', query: { num: a, time: timestamp } })
        },
        jumpWebs() {
            window.location.href = 'https://open.gjwec.com/#/'
        },

        jumpgh(a) {
            let timestamp = Date.now();
            this.$router.replace({ name: 'coop', query: { num: a, time: timestamp } })
        },
        // 新闻接口
        getNews() {
            let that = this
            axios.get('https://news-admin.gjwec.com/api/index/getNewsList', {
                params: {
                    page: 1,
                    pageSize: 6
                }
            }).then((res) => {
                console.log(res);
                if (res.data.data.data.length > 0) {
                    that.newsDatas = res.data.data.data;
                }
                console.log(that.newsDatas, '---------');

            })
                .catch((error) => {
                    console.error('Error fetching news:', error);
                });
        },
        getNewsList(a) {
            let that = this
            this.loinshow = true
            axios.get('https://news-admin.gjwec.com/api/index/getNewsList', {
                params: {
                    page: a,
                    pageSize: 6
                }
            }).then((res) => {
                console.log(res);
                if (res.data.data.data.length > 0) {
                    that.newsDatas = res.data.data.data;
                    this.loinshow = false
                }
                console.log(that.newsDatas, '---------');

            })
                .catch((error) => {
                    console.error('Error fetching news:', error);
                });
        },
        toTime(timestamp) {
            var date = new Date(timestamp * 1000);
            var Y = date.getFullYear() + '-';
            var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
            var D = date.getDate() + ' ';
            return Y + M + D;
        },
    },
};
</script>

<style scoped>
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

/* 第一个轮播图视频 */
.textara {
    box-sizing: border-box;
    position: absolute;
    left: 50%;
    bottom: 15%;
    transform: translate(-50%, -50%);
    height: auto;
    flex-direction: column;
    color: #fff;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.text-cons {
    font-size: 65px;
    padding-bottom: 20px;
}

.text-fonts {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80%;
    font-size: 20px;
    flex-direction: column;
}

.but-tex {
    background: linear-gradient(90deg, #34e5fd 0%, #db9bfe 100%);
    border-radius: 50px;
    /* box-shadow: '0px 4px 8px rgba(52, 229, 253, 0.5), 0px 8px 16px rgba(219, 155, 254, 0.5)'; */
    color: #fff;
    width: 230px;
    position: absolute;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    bottom: 340px;
    cursor: pointer;
    left: 150px;
}

/* 导航栏颜色 */
.top-business-con {
    position: absolute;
    bottom: 50px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 5;
    width: 100%;
    max-width: 1200px;
    display: flex;
    justify-content: center;
}

.top-business-con .tab-nav {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-bottom: 0;
    background: rgba(255, 255, 255, 0.5);
    padding: 15px;
    border-radius: 50px;
}

.top-business-con .tab-item {
    padding: 10px 20px;
    cursor: pointer;
    border-radius: 6px;
    transition: all 0.3s ease;
    font-size: 16px;
    color: #2c3e50;
}

.top-business-con .tab-item:hover {
    background: rgba(255, 255, 255, 0.1);
    color: #333;
}

.top-business-con .tab-item.active {
    background: linear-gradient(90deg, #BFE9FF 0%, #D6E2FF 100%);
    color: #2D7CFE;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.01);
    border-radius: 50px;
}

/* 响应式设计 */
@media (max-width: 768px) {
    .top-business-con {
        bottom: 80px;
        padding: 0 20px;
    }

    .top-business-con .tab-nav {
        flex-wrap: wrap;
        gap: 10px;
        padding: 10px;
    }

    .top-business-con .tab-item {
        font-size: 14px;
        padding: 8px 15px;
    }
}

@media (max-width: 480px) {
    .top-business-con .tab-nav {
        gap: 5px;
        padding: 8px;
    }

    .top-business-con .tab-item {
        font-size: 12px;
        padding: 6px 12px;
    }

    .strategy-container {
        padding: 0 10px;
    }

    .strategy-row {
        gap: 10px;
    }

    .strategy-item {
        min-height: 220px;
    }

    .strategy-item.expanded {
        min-height: 300px;
    }

    .strategy-icon {
        width: 50px;
        height: 50px;
    }

    .strategy-icon img {
        width: 30px;
        height: 30px;
    }

    .strategy-title {
        font-size: 14px;

    }

    .strategy-subtitle {
        font-size: 10px;
    }

    .strategy-content {
        font-size: 11px;
        padding: 5px;
        min-height: 60px;
    }

    .expand-icon {
        bottom: 5px;
    }

    .expand-icon img {
        width: 20px;
        height: 20px;
    }
}

/* 从左往右 */
.animated-title {
    animation: slideInFromLeft 0.8 ease-out forwards;
    transform: translateX(-100%);
}

@keyframes slideInFromLeft {
    0% {
        transform: translateX(-100%);
        opacity: 0;
    }

    100% {
        transform: translateX(0);
        opacity: 1;
    }
}

.animated-content {
    animation: slideInFromLeftContent 0.8s ease-out forwards;
    transform: translateX(-100%);
    opacity: 0;
}

@keyframes slideInFromLeftContent {
    0% {
        transform: translateX(-100%);
        opacity: 0;
    }

    100% {
        transform: translateX(0);
        opacity: 1;
    }
}

/* 顶部按钮 */
.top-nav {
    width: 40px;
    height: 40px;
    position: fixed;
    right: 0em;
    top: 370px;
    z-index: 1000;
    cursor: pointer;
    transition: all 0.3s ease;
}

.top-nav:hover {
    transform: scale(1.1);
}

#mySwiper {
    width: 100%;
    height: 100vh;
    overflow: hidden;
}

.swiper-pagination {
    right: 1em;
}

/* 四个轮播 */
/* 配置分页器的颜色 */
#swiperTop {
    --swiper-pagination-color: #ffffff;
    /* 未选中状态颜色为白色 */
    --swiper-pagination-current-color: #0000ff;
    /* 选中状态颜色为蓝色 */
}

/* 如果想要分页器小圆点的大小和样式进行微调 */
.swiper-pagination-bullet {
    width: 10px;
    height: 10px;
    border-radius: 50%;
}

.swiper-pagination-bullet-active {
    background-color: #0000ff;
    /* 选中的小圆点颜色为蓝色 */
}

.top-pagination {
    position: absolute;
    bottom: 70px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 10;
    display: flex;
    justify-content: center;
    align-items: center;
}

.top-pagination .swiper-pagination-bullet {
    width: 8px;
    height: 8px;
    margin: 0 5px;
    background: #fff;
    opacity: 1;
    transition: all 0.3s ease;
}

.top-pagination .swiper-pagination-bullet-active {
    background: #fff;
    opacity: 0.5;
}

#swiperTwo {
    height: 600px;
    --swiper-pagination-color: #2D7CFE;
    /* 未选中状态颜色为白色 */
    --swiper-pagination-current-color: #0000ff;
    /* 选中状态颜色为蓝色 */
}

.top-pagination,
.two-pagination,
.swiperbotom {
    position: absolute;
    width: 100%;
    justify-content: center;
    bottom: 10px;
    display: flex !important;
    z-index: 15;
}

.top-pagination .swiper-pagination-bullet {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #ccc;
    opacity: 1;
    transition: background 0.3s;
}

.two-pagination .swiper-pagination-bullet {
    width: 8px;
    height: 8px;
    margin: 0 5px;
    background: #555;
    /* 未选中时为灰色 */
    opacity: 1;
    transition: all 0.3s ease;
}

.top-pagination .swiper-pagination-bullet-active {
    background: #2D7CFE;
    /* 选中时为蓝色 */
}

.dots {
    width: 10px;
    height: 10px;
    border-radius: 100%;
    background-color: rgba(0, 0, 0, 0.2);
}

.dotsActive {
    background: #2D7CFE;
}

/* 1合作方式 */
.tit-top {
    display: flex;
    padding-top: 100px;
    align-items: center;
    justify-content: center;
    font-size: 28px;
    color: #000;
    font-weight: 600;
    flex-wrap: wrap;
}

.twos-con {
    display: flex;
    flex-wrap: wrap;
    /* 保持此属性，以允许换行 */
    justify-content: space-between;
    margin-top: 30px;
    width: 80%;
    margin-left: 10%;
}

.twos-item {
    background: #fff;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-wrap: wrap;
    width: calc(34% - 24px);
    margin-top: 40px;
    padding-bottom: 10px;
    position: relative;
    cursor: pointer;
    justify-content: space-between;
}

.twos-img {
    /* border: 1px solid red; */
    width: 100%;
    height: 240px;
    border-radius: 10px;
    margin-bottom: 8px;
}

.twos-text {
    position: absolute;
    bottom: 20px;
    left: 0;
    width: 100%;
    background-color: rgba(7, 56, 218, 0.5);
    color: #fff;
    text-align: left;
    padding: 10px;
    transition: opacity 0.3s ease;
    opacity: 1;
    padding-left: 20px;
    font-size: 15px;
    z-index: 2;
    border-radius: 10px;
}

.hover-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 91%;
    background-color: rgba(7, 56, 218, 0.5);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    opacity: 0;
    transition: opacity 0.3s ease;
    z-index: 1;
    border-radius: 10px;
}

.twos-item:hover .hover-overlay {
    opacity: 1;
}

.twos-item:hover .twos-text {
    opacity: 1;
    position: absolute;
    bottom: 60%;
    left: 50%;
    transform: translate(-50%, 50%);
    text-align: center;
    z-index: 3;

}

.lgs {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
    padding-left: 40px;
    margin-top: 120px;
    cursor: pointer;
}

.lgs img {
    width: 20px;
    /* 缩小图片大小 */
    height: auto;
    /* 保持图片比例 */
}

.loading-animation {
    width: 50px;
    height: 50px;
    border: 5px solid rgba(255, 255, 255, 0.3);
    border-top: 5px solid #000;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.backCon {
    display: flex;
    justify-content: center;
    padding: 20px;
    width: 100%;
}

.cardTwo {
    display: flex;
    position: relative;
    justify-content: space-between;
    width: 75%;
}

.left-button,
.right-button {
    position: absolute;
    top: 60%;
    transform: translateY(-40%);
    cursor: pointer;
}

.left-button {
    left: 10px;
}

.left-button img {
    width: 40px;
    height: 40px;
}

.right-button {
    right: 10px;
}

.right-button img {
    width: 40px;
    height: 40px;
}

.card-header {
    background-image: url('../assets/jt1.png');
    background-size: cover;
    padding: 20px;
    border-radius: 10px;
    color: #fff;
    text-align: center;
}


/* 新闻动画效果 - 从左往右 */
.animated-news-item {
    animation: slideInFromLeftNews 0.8s ease-out forwards;
    transform: translateX(-100%);
    opacity: 0;
}

@keyframes slideInFromLeftNews {
    0% {
        transform: translateX(-100%);
        opacity: 0;
    }

    100% {
        transform: translateX(0);
        opacity: 1;
    }
}

/* 上排证书从左向右动画 - 居中对齐 */
.animated-cert-left {
    animation: slideInFromLeftCert 1s ease-out forwards;
    transform: translateX(-100%);
    opacity: 0;
}

@keyframes slideInFromLeftCert {
    0% {
        transform: translateX(-100%);
        opacity: 0;
    }

    100% {
        transform: translateX(0);
        opacity: 1;
    }
}

/* 下排证书整体从右向左动画 */
.animated-bottom-row {
    animation: slideInFromRightRow 1s ease-out forwards;
    transform: translateX(100%);
    opacity: 0;
}

@keyframes slideInFromRightRow {
    0% {
        transform: translateX(100%);
        opacity: 0;
    }

    100% {
        transform: translateX(0);
        opacity: 1;
    }
}

.animated-image {
    animation: slideInFromRight 0.8s ease-out forwards;
    transform: translateX(100%);
    opacity: 0;
}

@keyframes slideInFromRight {
    0% {
        transform: translateX(100%);
        opacity: 0;
    }

    100% {
        transform: translateX(0);
        opacity: 1;
    }
}

/* 合作伙伴动画 */
.animated-partner-row-delay1 {
    animation: slideInFromRight 1s ease-out forwards;
}

/* 底部导航栏 */
.footer {
    width: 100%;
    height: 340px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    color: #000;
    position: absolute;
    bottom: 0;
}

.footer_top {
    width: 100%;
    height: 300px;
    border-bottom: 1px solid #fff;
    display: flex;
    justify-content: center;
    padding-top: 30px;

}

.footerTopLeft {
    width: 50%;
    height: 210px;
    display: flex;
    justify-content: space-around;
    /* border: 1px solid; */
    margin-top: 20px;
}

.LeftCon p {
    font-size: 27rpx;
    text-align: center;
    color: #989898;
    cursor: pointer;
    line-height: 2.5;
}

.LeftCon h4 {
    color: #000;
    text-align: center;
    cursor: pointer;
    font-size: 18px;
}

.RightCon p {
    color: #989898;
    cursor: pointer;
}

/* 右边四个 */
.footerTopRight {
    height: 240px;
    font-size: 14px;
    position: relative;
    left: 3%;
    width: 40%;
}

.RightCon {
    height: 18%;
    display: flex;
    align-items: center;
}

.RightCon img {
    width: 25px;
    height: 25px;
    margin-right: 15px;
}

.RightCon p {
    color: #000;
    margin: 0;
    line-height: 25px;
}



.footerMidd {
    width: 70%;
    height: 75%;
    border-bottom: 1px solid #cacaca;
}

.code {
    position: absolute;
    right: 18%;
    top: 0;
    width: 35%;
    align-items: center;
    justify-content: space-around;
    display: flex;
}

.codes {
    width: 23%;
    height: 60%;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.codes img {
    width: 100%;
    height: 100%;
}

.code h5 {
    margin-top: 10px;
}

.footer_botm {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 80px;
    font-size: 16px;
}

.card-imgs {
    flex: 1;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 0;
    object-fit: fill;
    position: relative;
}

.vjs-custom-skin {
    width: 100%;
    height: 100%;
}

.video-js {
    width: 100% !important;
    height: 100% !important;
    min-height: 300px;
}

.video-js video {
    object-fit: cover;
}

/* 响应式布局调整 */
@media (max-width: 768px) {
    .card-imgs {
        max-width: 100%;
        margin-right: 0;
    }

    .card-imgs .video-js {
        min-height: 250px;
    }
}

.gradient-con {
    position: absolute;
    margin-top: -380px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.gradient-text {
    font-size: 70px;
    /* 设置字体大小 */
    font-weight: bold;
    /* 可选的加粗 */
    background: linear-gradient(90deg, #30EDFC 0%, #304EFC 100%);
    -webkit-background-clip: text;
    /* Safari和Chrome支持 */
    background-clip: text;
    /* 适用于Firefox */
    color: transparent;
    /* 使文字透明，从而显示背景渐变 */
    padding-bottom: 30px;
}

.gradient-p {
    font-size: 40px;
    /* 设置字体大小 */
    font-weight: bold;
    color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/views/news.vue